// Lokal und DEV (npm start, npm run build:dev). Production ersetzt diese Datei durch environment.prod.ts.
import { buildInfo } from './build-info';

export const environment = {
  production: false,
  paypalClientId: 'Aaq-ZgHVNQA21hQoeLMar5xyMaFEDzNpvuEkr37nAXy2WczhXT3ozeB5xIlfm5voGfUclGoOJPGPAPy3',
  version: '2.2.0',
  versionName: '[.elisa]',
  apiUrl: 'https://dev-api-skilltoolbox.webadelic.eu/api/',
  frontendUrl: 'https://dev.skill-toolbox.de',
  buildInfo
};
